import { supabase, isSupabaseConfigured } from '../../lib/supabaseClient';
import type { Profile } from '../../lib/supabaseClient';

// Helper para verificar configuración antes de usar Supabase
function ensureSupabase() {
  if (!isSupabaseConfigured() || !supabase) {
    throw new Error('Supabase no está configurado. Por favor, configura las variables de entorno.');
  }
  return supabase;
}

export async function signUp(email: string, password: string, fullName: string) {
  const client = ensureSupabase();
  const { data, error } = await client.auth.signUp({
    email,
    password,
    options: {
      data: {
        full_name: fullName,
      },
    },
  });

  if (error) throw error;
  return data;
}

export async function signIn(email: string, password: string) {
  const client = ensureSupabase();
  const { data, error } = await client.auth.signInWithPassword({
    email,
    password,
  });

  if (error) throw error;
  return data;
}

export async function signOut() {
  const client = ensureSupabase();
  const { error } = await client.auth.signOut();
  if (error) throw error;
}

export async function getSession() {
  const client = ensureSupabase();
  const { data, error } = await client.auth.getSession();
  if (error) throw error;
  return data.session;
}

export async function getProfile(userId: string): Promise<Profile> {
  const client = ensureSupabase();
  const { data, error } = await client
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .single();

  if (error) throw error;
  return data;
}

export async function updateMyProfile(fullName: string) {
  const client = ensureSupabase();
  const { data, error } = await client.rpc('update_my_profile', {
    p_full_name: fullName,
  });

  if (error) throw error;
  return data;
}
